import t1 from "../../assets/images/tray/t1.svg";
import t2 from "../../assets/images/tray/t2.svg";
import t3 from "../../assets/images/tray/t3.svg";
import t4 from "../../assets/images/tray/t4.svg";
import t5 from "../../assets/images/tray/t5.svg";
import { useDrag, useDrop } from "react-dnd";

// Styles
import "./styles.scss";
import { useDispatch } from "react-redux";
import {
  discardBurger,
  increasePattiesTrashed,
  removefromGrillQueue,
} from "../../store/ingredient";
const Ingedient = (props) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "ingredient",
    item: { index: props.index, name: props.name },

    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <img
      src={props.image}
      alt=""
      ref={drag}
      style={{ opacity: isDragging ? "0.5" : "1" }}
    />
  );
};

export default function TrayCard(props) {
  const dispatch = useDispatch();
  const ingredArray = [
    { image: t2, name: "cheese" },
    { image: t3, name: "lettuce" },
    { image: t4, name: "bun" },
  ];
  const [{ isDragging }, patty] = useDrag(() => ({
    type: "patty",
    item: { index: 0, name: "patty" },

    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const [{ isOver }, drop] = useDrop({
    accept: ["burger", "ingredient"],
    drop: (item, monitor) => {
      if (
        ["pattyCooked", "pattyUnCooked", "pattyOverCooked"].includes(item?.name)
      ) {
        dispatch(
          removefromGrillQueue({
            index: item.index,
          })
        );
        dispatch(increasePattiesTrashed());
      }
      if (!item?.name) {
        dispatch(discardBurger(item.index));
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const [{ isOver: isMobileDropOver }, mobileDrop] = useDrop({
    accept: ["burger", "ingredient"],
    drop: (item, monitor) => {
      if (
        ["pattyCooked", "pattyUnCooked", "pattyOverCooked"].includes(item?.name)
      ) {
        dispatch(
          removefromGrillQueue({
            index: item.index,
          })
        );
        dispatch(increasePattiesTrashed());
      }
      if (!item?.name) {
        dispatch(discardBurger(item.index));
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  return (
    <div className={`tray-section-style ${props.className || ""}`}>
      <div className="tray-card-style">
        <div className="items-desk" style={{ transition: "none !important" }}>
          <img
            src={t1}
            alt=""
            ref={patty}
            style={{ opacity: isDragging ? "0.5" : "1" }}
          />
          {ingredArray.map((item, index) => (
            <Ingedient
              image={item.image}
              index={index}
              key={index}
              name={item.name}
            />
          ))}
          <img
            src={t5}
            alt=""
            ref={mobileDrop}
            style={{ opacity: isMobileDropOver ? 0.5 : 1 }}
          />
        </div>
      </div>
      <div
        className="trash-box"
        ref={drop}
        style={{ opacity: isOver ? 0.5 : 1 }}
      />
    </div>
  );
}
